export const companiesConstants  = {
  SET_CURRENT_COMPANY: 'SET_CURRENT_COMPANY'
};